// extracted by mini-css-extract-plugin
export default {"cssloadContainer":"Loader_cssloadContainer__ltkdV","cssloadZenith":"Loader_cssloadZenith__XgE6J","cssload-spin":"Loader_cssload-spin__uEvd4"};